import atticusJpg from './atticus-optimized.jpeg';
import atticusWebp from './atticus-optimized.webp';
import obiJpg from './obi-optimized.jpeg';
import obiWebp from './obi-optimized.webp';
import tyJpg from './ty-optimized.jpeg';
import tyWebp from './ty-optimized.webp';

export const atticusSources = [atticusWebp, atticusJpg];
export const obiSources = [obiWebp, obiJpg];
export const tySources = [tyWebp, tyJpg];
